import { useEffect, useState } from "react";
import { Mail, Phone, MapPin, Home, Inbox } from "lucide-react";
import api from "@/lib/api";
import AdminLayout from "@/components/admin/AdminLayout";

export default function Contacts() {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/contacts").then((r) => setContacts(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <AdminLayout title="Richieste di contatto">
      {loading ? (
        <p className="text-brand-plum/40">Caricamento...</p>
      ) : contacts.length === 0 ? (
        <div className="rounded-2xl bg-white border border-brand-plum/8 p-16 text-center">
          <Inbox className="mx-auto text-brand-plum/30 mb-3" size={40} />
          <p className="font-serif text-xl text-brand-plum">Nessuna richiesta</p>
          <p className="text-brand-plum/50 mt-1">Le richieste di preventivo dal form contatti appariranno qui.</p>
        </div>
      ) : (
        <div className="space-y-4" data-testid="contacts-list">
          {contacts.map((c) => (
            <div key={c.id} className="rounded-2xl bg-white border border-brand-plum/8 shadow-sm p-6" data-testid={`contact-item-${c.id}`}>
              <div className="flex flex-wrap items-start justify-between gap-3">
                <div>
                  <p className="font-serif text-xl text-brand-plum">{c.first_name} {c.last_name}</p>
                  <div className="flex flex-wrap gap-4 mt-2 text-sm text-brand-plum/60">
                    <span className="flex items-center gap-1.5"><Mail size={14} className="text-brand-teal" /> {c.email}</span>
                    {c.phone && <span className="flex items-center gap-1.5"><Phone size={14} className="text-brand-teal" /> {c.phone}</span>}
                    {c.city && <span className="flex items-center gap-1.5"><MapPin size={14} className="text-brand-teal" /> {c.city}</span>}
                    {c.num_properties && <span className="flex items-center gap-1.5"><Home size={14} className="text-brand-teal" /> {c.num_properties} strutture</span>}
                  </div>
                </div>
                <span className="text-xs text-brand-plum/40">{new Date(c.created_at).toLocaleString("it-IT")}</span>
              </div>
              {c.message && <p className="mt-4 text-sm text-brand-plum/70 bg-brand-warm/50 rounded-xl p-4">{c.message}</p>}
            </div>
          ))}
        </div>
      )}
    </AdminLayout>
  );
}
